import React from 'react';

import { Button } from 'wanderu-components';
import { localize, i18nMoment as ourMoment } from 'wanderu-i18n';
import {
    ChevronRight,
} from 'wanderu-icons';

import SearchButton from '../SearchButton/SearchButton';

import styles from './MinimizedWidgetBody.scss';

interface MinimizedWidgetBodyProps {
    departDate: string;
    destinationInput?: string;
    disabled: boolean;
    i18nMoment: typeof ourMoment;
    locale: string;
    onSearch: () => void;
    onToggle: () => void;
    originInput: string;
    returnDate: string;
    title: string;
}

function MinimizedWidgetBody(props: MinimizedWidgetBodyProps) {
    const {
        departDate,
        destinationInput,
        disabled,
        i18nMoment,
        locale,
        onSearch,
        onToggle,
        originInput,
        returnDate,
        title,
    } = props;

    return (
        <div className={styles.minimizedSticky}>
            <Button
                className={styles.minimizedSearchWidget}
                onClick={onToggle}
                unstyled
            >
                <div className={styles.tripField}>
                    {!!originInput?.trim() && !!destinationInput?.trim()
                        ? (
                            <>
                                <span>{originInput}</span>
                                <ChevronRight className={styles.chevron} />
                                <span>{destinationInput}</span>
                            </>
                        )
                        : (
                            <span>{title}</span>
                        )}
                </div>
                <div className={styles.dateField}>
                    <span>
                        {i18nMoment(departDate).shortDayAndWeekday(locale)}
                    </span>
                    {returnDate && (
                        <>
                            <span> - </span>
                            <span>
                                {i18nMoment(returnDate).shortDayAndWeekday(locale)}
                            </span>
                        </>
                    )}
                </div>
            </Button>
            <SearchButton
                className={styles.smallSearchButton}
                disabled={disabled}
                onClick={onSearch}
                noLabel
            />
        </div>
    );
}

export { MinimizedWidgetBody };
export default localize(MinimizedWidgetBody, ['i18nMoment'], 'widget');
